var map = {
	"./akbars.svg": 577,
	"./alfa.svg": 467,
	"./gaztransbank.svg": 929,
	"./mtsbank.svg": 133,
	"./otpbank.svg": 804,
	"./ozon.svg": 279,
	"./psb.svg": 422,
	"./raiffeisenbank.svg": 161,
	"./rshb.svg": 724,
	"./sber.svg": 669,
	"./solidarnost.svg": 593,
	"./tinkoff-dark.svg": 923,
	"./tinkoff.svg": 450,
	"./uralsib.svg": 49,
	"./vtb.svg": 181,
	"./yandex.svg": 928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;